// extracted by mini-css-extract-plugin
export default {"container":"FormHeading_container__9biAP","heading":"FormHeading_heading__fX85i","subHeading":"FormHeading_subHeading__DbpA+","closeButton":"FormHeading_closeButton__hloJK"};